import * as helper from './helper'
import * as CONFIG from '../config/index'
import axios from 'axios'

export const IDEA_WORKFLOW_API_URL = `${CONFIG.API_URL}/idea-workflow`;

export const getAction = async function (status) {
  try {
    let res = await axios.get(`${IDEA_WORKFLOW_API_URL}/get-action?status=${status}`);
    return res.data.data;
  } catch (e) {
    helper.notifyError(e);
  }
}

export default {
  getAction: getAction
}



// WEBPACK FOOTER //
// ./src/common/ideaWorkflow.js